import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';

const approvalForm = {
  showForm: true,
  form: 'Approval',
  formTitle: 'Justificación de Aprobado',
  formIcon: 'fa-flag',
  formColor: '#2db782',
};

const disapprovalForm = {
  showForm: true,
  form: 'Disapproval',
  formTitle: 'Razón para No Aprobar',
  formIcon: 'fa-flag',
  formColor: '',
};

const deniedForm = {
  showForm: true,
  form: 'Denegado',
  formTitle: 'Denegación de Consulta',
  formIcon: 'fa-flag',
  formColor: '',
};

export const UTA_MANAGEMENT_STATUS_TARGET_CONFIG = {
  [tapRequestStatusesEnum['Aprobado']]: approvalForm,
  [tapRequestStatusesEnum['No Aprobado']]: disapprovalForm,
  [tapRequestStatusesEnum['Notificado']]: approvalForm,
  [tapRequestStatusesEnum['Denegado']]: deniedForm,
};
